import { css } from "@emotion/react";
import { ThemedCssCreator } from "../../../../config/emotion";

export const invalidInputCss: ThemedCssCreator = (theme) => css`
  border: 2px solid ${theme.colors.delete};
`;

export const inputCss = css`
  width: 100%;
  margin-bottom: 10px;
`;

export const modalCss = css`
  min-width: 500px;
`;
